import React from 'react';
import { FadeIn } from './FadeIn';
import { FileTextIcon, TargetIcon, SmileIcon, TrophyIcon } from 'lucide-react';
export function ResourcesPreview() {
  const resources = [{
    icon: FileTextIcon,
    tag: 'Herramienta',
    title: '20 Tarjetas de Rescate',
    desc: 'Protocolos exactos para destrabar cada tipo de bloqueo en el momento.',
    color: 'primary'
  }, {
    icon: TargetIcon,
    tag: 'Práctica',
    title: '15 Fichas de Misión',
    desc: 'Ejercicios contextuales listos para usar que conectan con la vida real.',
    color: 'amber'
  }, {
    icon: SmileIcon,
    tag: 'Rutina',
    title: 'Cuaderno de Práctica Dopamina',
    desc: 'Sesiones de 10 minutos diseñadas para generar pequeñas victorias.',
    color: 'primary'
  }, {
    icon: TrophyIcon,
    tag: 'Motivación',
    title: 'Sistema de Logros tipo Videojuego',
    desc: 'Un mapa visual donde avanza, gana medallas y ve su progreso.',
    color: 'amber'
  }];
  return <section className="py-14 md:py-20 bg-surfaceLight/30 border-t border-slate-200" data-id="element-427">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-428">
        <FadeIn data-id="element-429">
          <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-430">
            <span className="inline-block bg-amber/10 text-amber-dark border border-amber/30 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4" data-id="element-431">
              Solo en versión Premium
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-slate-900 mb-3" data-id="element-432">
              EL KIT ACELERADOR MATEMÁTICO
            </h2>
            <p className="text-slate-600" data-id="element-433">
              Herramientas de implementación listas para imprimir y usar desde
              el primer día.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-id="element-434">
          {resources.map((res, i) => {
          const Icon = res.icon;
          const isPrimary = res.color === 'primary';
          return <FadeIn key={i} delay={i * 0.08} data-id="element-435">
                <article className="bg-white rounded-2xl border border-slate-100 shadow-soft p-5 h-full hover:shadow-soft-lg hover:-translate-y-1 transition-all duration-300" data-id="element-436">
                  <div className="flex items-center justify-between gap-3 mb-3" data-id="element-437">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${isPrimary ? 'bg-primary/10 text-primary-dark' : 'bg-amber/10 text-amber-dark'}`} data-id="element-438">
                      <Icon className="w-5 h-5" data-id="element-439" />
                    </div>
                    <span className={`text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-lg border ${isPrimary ? 'bg-primary/5 text-primary-dark border-primary/20' : 'bg-amber/5 text-amber-dark border-amber/20'}`} data-id="element-440">
                      {res.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-extrabold text-slate-900 mb-1.5 leading-tight" data-id="element-441">
                    {res.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-snug" data-id="element-442">
                    {res.desc}
                  </p>
                </article>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}